import React, { useState } from 'react'
import CustomTable from '../../shared/CustomTable'
import { useTranslation } from 'react-i18next'

function ClaimsProcessingTable () {
  const { t } = useTranslation()
  const [loading, serLoading] = useState(false)
  return (
    <div className='pre_auth_container !p-0 '>
      <CustomTable
        headers={[
          'Date',
          'File No',
          'Patient Name',
          'Payer',
          'Physician',
          'Department',
          'Status'
        ]}
        // rows={[{ Name: 'John Doe', Age: 28, Location: 'New York' }]}
      />
    </div>
  )
}

export default ClaimsProcessingTable
